/* stylelint-disable no-undef */
// import external dependencies
import 'jquery';
import './autoload/_bootstrap.js';
// Import autoload files
import './autoload/jquery.waypoints.min.js';
import './autoload/jquery.countup.min.js';
import './autoload/select2.min.js';
import './autoload/jquery.unveil.js';
// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import guaranteedFixedPriceQuotes from './routes/guaranteedFixedPriceQuotes';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  guaranteedFixedPriceQuotes,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// SVG scroll animation
window.onwheel = e => {
  const svg = document.getElementById('mySVG');
  if (!svg) return;

  if (e.deltaY >= 0) {
    // Scrolling Down with mouse
    svg.classList.add('animate');
  } else {
    // Scrolling Up with mouse
    svg.classList.remove('animate');
  }
};
